// **********************************************************
// Main menu dropdown
// **********************************************************
attachEvent('.menu__arrow', 'click', (ev) => {
  const arrowParent = ev.target.closest('.menu__item');
  arrowParent.classList.toggle('is-open-submenu');

  if (windowWidth() < breakpointMd) {
    const menuDropdown = arrowParent.querySelector('.menu__dropdown');
    slideToggle(menuDropdown, 300, 'block');
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.menu__item').forEach((el) => {
      el.classList.remove('is-open-submenu');
    });
  }
});
